import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { PillSelectionFilterComponent } from '../pill-selection-filter/pill-selection-filter.component';
import { RadioFilterComponent } from '../radio-filter/radio-filter.component';
import { CheckboxFilterComponent } from '../checkbox-filter/checkbox-filter.component';
import { TypeaheadFilterComponent } from '../typeahead-filter/typeahead-filter.component';
import { SidePanelService } from '../../../../../core';
import { TableFilterGroup, TableFilterType } from '../../models/table-filter';
import { ButtonType } from '../../../enum/button-type.enum';
import { DialogHeaderComponent } from '../../../dialog/dialog-header/dialog-header.component';
import { ButtonComponent } from '../../../buttons/button/button.component';
import { Tab, TabGroupComponent } from '../../../tab-group/tab-group.component';
import { NumericFilterComponent } from '../numeric-filter/numeric-filter.component';
import { DateFilterComponent } from '../date-filter/date-filter.component';

@Component({
  selector: 'lib-table-filters',
  imports: [
    DialogHeaderComponent,
    ButtonComponent,
    PillSelectionFilterComponent,
    TabGroupComponent,
    RadioFilterComponent,
    CheckboxFilterComponent,
    TypeaheadFilterComponent,
    NumericFilterComponent,
    DateFilterComponent,
  ],
  templateUrl: './table-filters.component.html',
  styleUrl: './table-filters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableFiltersComponent {
  sidePanelService = inject(SidePanelService);
  tableFilterGroups = signal<TableFilterGroup[]>([]);
  selectedGroupIndex = signal<number>(0);

  tabs = computed(() => {
    return this.tableFilterGroups().map((g, i) => new Tab(g.groupName, i));
  });

  selectedGroup = computed(() => {
    return this.tableFilterGroups()[this.selectedGroupIndex()];
  });

  protected readonly ButtonType = ButtonType;
  protected readonly TableFilterType = TableFilterType;

  initializeTableFilterGroups(filterGroups: TableFilterGroup[]) {
    filterGroups.forEach(group => {
      group.filters.forEach(f => {
        f.unsavedOptions = structuredClone(f.options()).map(tableFilterOption => {
          // this code is somewhat counterintuitive,
          // but we have to do it because you can't store a signal inside of a signal,
          // esp not if you want to clone it...
          // but we need signals in this case for reactive ui while staying zoneless
          return {
            ...tableFilterOption,
            isSelected: signal(tableFilterOption.selected),
          };
        });
      });
    });
    this.tableFilterGroups.set(filterGroups);
  }

  closeClicked() {
    this.sidePanelService.close();
  }

  updateFiltersClicked() {
    this.sidePanelService.close(true);
  }

  resetAllClicked() {
    this.tableFilterGroups().forEach(g => {
      g.filters.forEach(f => {
        f.resetUnsavedOptions();
      });
    });
  }
}
